import React from 'react';
import CitySearchForm from '../Form/CitySearchForm';
import { Helmet } from 'react-helmet';
import wave from '../../../static/waves/header-mobile.svg';

interface DataContext {
  drupalData: Queries.paragraph__header_with_search;
  additionalData: {
    pageSettings: Queries.config_pages__page_settings;
    allCities: Queries.City[];
  };
}

export default function HeaderWithSearch({
  drupalData,
  additionalData,
}: DataContext): React.JSX.Element {
  return (
    <>
      <Helmet>
        <script src="/header-animation.js" type="text/javascript"></script>
      </Helmet>

      <header className="vl-region animated-header">
        <div className="vl-layout">
          <div className="vl-grid vl-grid--align-center">
            <div className="centered vl-u-spacer-top--small vl-u-spacer-bottom--large">
              <h1 className="vl-title vl-title--h1 vl-u-align-center vl-u-spacer-bottom--small">
                {drupalData.field_title}
              </h1>
              <p className="vl-introduction vl-u-align-center vl-u-spacer-bottom--small">
                {drupalData.field_description}
              </p>
              <CitySearchForm
                cityDashboardPath={additionalData.pageSettings.relationships.field_dashboard_city.path.alias}
                allCities={additionalData.allCities}
              />
            </div>
          </div>
        </div>
        <div id="lottie"></div>
        <img src={wave} className="waves" alt="wave" />
      </header>
    </>
  );
}
